<div class="win-overlay" *ngIf="prize">
    <div class="prize">
        <h2>You won:</h2>
        <img *ngIf="prize.image" [src]="prize.image" alt="" />
        <i *ngIf="prize.type === 'coupon'" class="fa-solid fa-tag fa-3x"></i>
        <h3>{{ prize.name }}</h3>
        <h5 class="text-center">{{ standalone ? 'Complete the form to claim your prize.' : 'Your prize will automatically be redeemed once finished.' }}</h5>
        <button (click)="dismiss()">Claim Prize</button>
    </div>
</div>
